import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_BreakInService = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_BreakInService' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>Break in Service form</h3></p>
                <p className='w-750'>
                    BIS cannot exceed 60 days.
                </p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Start Date:</span></td>
                        <td className='w-375'><span className='eleHeader'>End Date:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'> <input type='date' id='txtStartDate' name='txtStartDate' className='add-only' /></td>
                        <td className='w-375'> <input type='date' id='txtEndDate' name='txtEndDate' className='add-only' /></td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Break in Service is Due To:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbInsuranceDenial' name='cbInsuranceDenial' className='add-only' value='1' /> Insurance Denial of Prior Authorization Request
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbInsuranceLoss' name='cbInsuranceLoss' className='add-only' value='2' /> Loss of Insurance
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbHospitalization' name='cbHospitalization' className='add-only' value='3' /> Hospitalization (Medical)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbVolunHospital' name='cbVolunHospital' className='add-only' value='4' /> Voluntary Hospitalization (Mental Health)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbInvolunHospital' name='cbInvolunHospital' className='add-only' value='5' /> Involuntary Hospitalization (Mental Health)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbNursingHome' name='cbNursingHome' className='add-only' value='6' /> Temporary Placement in Group Home/Assissted Living Facility/Nursing Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbIncarceration' name='cbIncarceration' className='add-only' value='7' /> Incarceration
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbHomeless' name='cbHomeless' className='add-only' value='8' /> Homeless
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSummerBreak' name='cbSummerBreak' className='add-only' value='9' /> Summer Break/Vacation/Temporarily Out-Of-Area
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbUnableContact' name='cbUnableContact' className='add-only' value='10' /> Unable to Contact
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbBreakOther' name='cbBreakOther' className='add-only' value='11' /> Other (Explain):
                            <input type='text' id='txtBreakOther' name='txtBreakOther' className='add-only w-375 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments:</span>
                    <textarea id='txtAdditionalComments' name='txtAdditionalComments' className='add-only'></textarea>
                </p>

            </div>
        </form>

    )
}











